module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07chapter01#c1"
    }
  }, [_vm._v("Ancestral Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/08chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animal Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apparitions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battlefield Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebrity Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deceiving Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guardian Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historic Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inhuman Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20chapter14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Materializations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21chapter15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monsters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/22chapter16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mythical Ghosts; Folklore Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/23chapter17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24chapter18#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Omen Ghosts; Prophetic Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/25chapter19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poltergeists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/26chapter20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Possessive Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/27chapter21#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/28chapter22#c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shadow Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/29chapter23#c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spirits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/30chapter24#c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spectral Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/31chapter25#c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vampires")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/32chapter26#c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warning Ghosts")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/33practical#pra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practical Ghost Hunting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/34furtherreading#fur",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/35index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c10e69de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05contents.vue
// module id = 72
// module chunks = 0